import { useEffect } from 'react';

import { useStores } from 'src/hooks/use-stores';
import { PusherConfig } from 'shared/constants';
import AdminPublicEnv from 'src/utils/admin-public-env';

function handleReloadApp(): void {
  console.debug('Dutchie has been updated, reloading...');
  window.location.reload();
}

export function usePusherAppReload(): void {
  const { Pusher } = useStores();

  useEffect(() => {
    // BO-hosted Admin intentionally has no browser access-token, so skip only
    // this legacy token-bound global reload subscription. Cookie-authenticated
    // hosted realtime is a separate follow-up; other Pusher usage is unchanged.
    if (AdminPublicEnv.isBackofficeHosted) {
      return undefined;
    }

    return Pusher.register(PusherConfig.Admin.CHANNEL, PusherConfig.Admin.Events.ReloadApp, handleReloadApp);
  }, [Pusher]);
}
